import { useLanguage } from '@/context/LanguageContext';

export const Stats = () => {
    const { t } = useLanguage();

    const stats = [
        { value: '9', label: t('home.stats.committees'), suffix: '' },
        { value: '500', label: t('home.stats.expectedDelegates'), suffix: '+' },
        { value: '3', label: t('home.stats.daysOfConference'), suffix: '' },
        { value: '50', label: t('home.stats.schoolsInvited'), suffix: '+' }
    ];

    return (
        <section className="py-20 bg-primary">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
                    {stats.map((stat, index) => (
                        <div
                            key={index}
                            className="text-center"
                            style={{ animationDelay: `${index * 100}ms` }}
                        >
                            <div className="flex items-center justify-center gap-1 mb-2">
                                <span className="font-display text-5xl sm:text-6xl font-bold text-accent">
                                    {stat.value}
                                </span>
                                {stat.suffix && (
                                    <span className="font-display text-3xl sm:text-4xl font-bold text-accent">
                                        {stat.suffix}
                                    </span>
                                )}
                            </div>
                            <p className="text-primary-foreground/70 font-medium text-sm sm:text-base uppercase tracking-wider">
                                {stat.label}
                            </p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Stats;
